import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入 Element-UI 的样式
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
});
import '@/css/styles.css'

Vue.use(ElementUI) // 全局引入 Element-UI

Vue.config.productionTip = false

// 如果你需要全局使用某些方法，比如 Message，可以这样：
Vue.prototype.$message = ElementUI.Message


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

